import { AssistanceService } from './assistanceservice';
import { Country } from './country';
import { Sponsor } from './sponsor';
import { AssistanceCollector } from './assistance_collector';
export class Assistance {
  id?: number;
  assistance_code?: string;
  country_id?: number;
  sponsor_id?: number;
  fronting_id?: number;
  email_info_id?: number;
  attachment_id: number;
  assistance_campaign_id?: number;
  name?: string;
  description?: string;
  status?: number;
  services?: AssistanceService[];
  updated_time?: string;
  created_time?: string;
  visable_flag: boolean = false;
  active_flag: boolean = false;
  sponsor: Sponsor;
  recurring_charge: boolean = false;
  charge_type: number;
  country?: Country;
  service_number?: string;
  cabin_contact_phones?: string;
  providers_cabin_contact_phones?: string;
  business_contract?:string;
  collector_id: number; // TODO: DEPRECATED
  assistance_collectors: AssistanceCollector[];
  collector_ids?: number[];
  region: string;
  loss_ratio_classification: string;
  assistance_company_id?:number;
  beneficiaries_allowed?:number;
}
